module.exports = __webpack_public_path__ + "assets/img/open.7dca1a17.svg";